import React, {useEffect, useRef, useState} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';

import {myService} from '@app/services/nhadanService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import {HRTag, Tabs} from "@components";
import {
    image_root  , INIT_ROLE_MENU
} from "@app/const/AppSetting";

import {useTranslation} from "react-i18next";
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {findObjInArr} from "@app/utils/CommonFunctions";
import CapcoquanListComponent from '@app/pages/FUtil/CapcoquanListComponent';
import CoquanListComponent from '@app/pages/FUtil/CoquanListComponent';
import NhadanListComponent from '@app/pages/FUtil/NhadanListComponent';
import {ClipLoader} from "react-spinners";
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import TailieuEdit from "@pages/FMasterData/FNhadan/TailieuEdit";

import LoainhadansListComponent from "@pages/FUtil/LoainhadanListComponent";
import CityListComponent from "@pages/FUtil/CityListComponent";

function NhadanEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const currController = getControllerName(location.pathname);
    console.log(currController);
    const [loading, setLoading] = useState(false);

    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);

    // Refs for scrollTo functionality
    const taiLieuRef = useRef(null);
    const thongtinRef = useRef(null);
    const vitriRef = useRef(null);

    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const [map, setMap] = useState(null);

    // ScrollTo functions
    const scrollToThongtin = () => {
        thongtinRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToTaiLieu = () => {
        taiLieuRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToVitri = () => {
        vitriRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const initial = {
        id: id || 0,
        loainhadan_fk:null,
        tructhuoc_fk:null,
        ten : '',
        dia_chi:'',
        lat:'',
        lon:'',
        link_map:'',
        city_code:'',
        ghi_chu:'',
        trangthai_fk:null
    };

    const [obj, setObj] = useState({...initial});

    const onChangeInput =  (e) => {
        const {name, value, checked} = e.target;

        if(name ==="xyz") {
        }
        else
        {
            setObj((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const createRs = async () => {
        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                console.log('getById', JSON.stringify(response, null, 2));
                if(!response || !response.data || !response.data.data)
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;
                setObj(userX);
            });
        }
    };

    useEffect(async () => {
        await checkRole({
            pathname: location.pathname,
            isAddMode,
            currController,
            history
        });

        await createRs();
    }, []);

    const saveClick = async () => {
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        if(!data.ten || data.ten.length === 0)
        {
            alert('Vui lòng nhập tên');
            return;
        }
        isAddMode ?  createUser(data) : update(data);
    };

    const backBrowse = () => {
        history.push('/'+currController);
    };

    async function createUser(data) {
        setLoading(true);
        const result = await myService.Create(data);
        if (result.status ==="1") {
            alertService.success(result.msg);
            history.push('/'+currController);
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    async function update(data) {
        setLoading(true);
        const result = await myService.Update(id,data);
        if (result.status ==="1") {
            alertService.success(result.msg);
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    let htmlButtonSave = '';

    if (isDisplay <= 0 || isAddMode > 0) {
        htmlButtonSave = (
            <>
                <Button
                    className="btn btn-success mr-1"
                    icon="right fas fa-angle-left"
                    onClick={saveClick}
                >
                    <i className="fa fa-save"> {isAddMode > 0 ? "Tạo mới" : "Cập nhật"} </i>
                </Button>
            </>
        );
    }

    // CSS Styles
    const formLabelStyle = {
        fontWeight: '500',
        color: '#495057',
        marginBottom: '5px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    };

    const formControlStyle = {
        border: '1px solid #ced4da',
        borderRadius: '6px',
        padding: '8px 12px',
        fontSize: '14px',
        transition: 'all 0.3s ease',
        backgroundColor: '#fff'
    };

    const iconStyle = {
        fontSize: '14px',
        marginRight: '8px'
    };

    return (
        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                {/* Navigation buttons - Fixed on right side */}
                { !isAddMode && (
                    <div style={{
                        position: 'fixed',
                        right: '0',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: '1000',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px'
                    }}>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToThongtin}
                        >
                            Thông tin chung
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToVitri}
                        >
                            Vị trí & Bản đồ
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToTaiLieu}
                        >
                            Tài liệu
                        </button>
                    </div>
                )}

                <div className="form-row p-2">
                    <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>

                <div className="tab-pane fade show active" id="thongtinnhanvien">
                    <div className="card-body" ref={thongtinRef}>
                        <HRTag title="Thông tin nhà đàn" />

                        {/* Row 1: Loại nhà đàn và Trạng thái */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <LoainhadansListComponent
                                    path_access={currController}
                                    loainhadan_fk={obj.loainhadan_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "loainhadan_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                            {!isAddMode && (
                                <div className="col-md-6">
                                    <TrangthaiListComponent
                                        trangthai_fk={obj.trangthai_fk}
                                        onChange={(opt, e) => {
                                            const target = {name: "trangthai_fk", value: opt?.value};
                                            onChangeInput({target});
                                        }}
                                        filterIds={[0,1]}
                                        trangthaiName="name"
                                    />
                                </div>
                            )}
                        </div>

                        {/* Row 2: Tên và Địa chỉ */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label style={{...formLabelStyle, fontWeight: '600'}}>
                                    <i className="fas fa-home text-primary" style={iconStyle}></i>
                                    Tên nhà đàn <span style={{color: '#dc3545', marginLeft: '3px'}}>*</span>
                                </label>
                                <input
                                    type='text'
                                    className="form-control"
                                    style={formControlStyle}
                                    name="ten"
                                    id="ten"
                                    value={obj.ten}
                                    onChange={(e) => onChangeInput(e)}
                                    placeholder="Nhập tên nhà đàn"
                                />
                            </div>
                            <div className="col-md-6">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-map-marker-alt text-danger" style={iconStyle}></i>
                                    Địa chỉ
                                </label>
                                <input
                                    type='text'
                                    className="form-control"
                                    style={formControlStyle}
                                    name="dia_chi"
                                    id="dia_chi"
                                    value={obj.dia_chi}
                                    onChange={(e) => onChangeInput(e)}
                                    placeholder="Nhập địa chỉ"
                                />
                            </div>
                        </div>

                        {/* Row 3: Thành phố và Trực thuộc */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <CityListComponent
                                    city_code={obj.city_code}
                                    onChange={(opt) => onChangeInput({ target: { name: "city_code", value: opt?.value } })}
                                />
                            </div>
                            <div className="col-md-6">
                                {obj.loainhadan_fk != "1" && obj.loainhadan_fk != null && (
                                    <NhadanListComponent
                                        labelName="Trực thuộc nhà đàn"
                                        loainhadan_fk_smaller={obj.loainhadan_fk}
                                        nhadan_fk={obj.tructhuoc_fk}
                                        onChange={(opt, e) => {
                                            const target = {name: "tructhuoc_fk", value: opt?.value};
                                            onChangeInput({target});
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        {/* Vị trí và Bản đồ Section */}
                        <div ref={vitriRef}>
                            <HRTag title="Vị trí & Bản đồ" />

                            {/* Row 4: Link map */}
                            <div className="row mb-3">
                                <div className="col-md-10">
                                    <label style={formLabelStyle}>
                                        <i className="fas fa-link text-info" style={iconStyle}></i>
                                        Link Google Maps
                                    </label>
                                    <input
                                        type='text'
                                        className="form-control"
                                        style={formControlStyle}
                                        name="link_map"
                                        id="link_map"
                                        value={obj.link_map}
                                        onChange={(e) => onChangeInput(e)}
                                        placeholder="Dán link Google Maps vào đây"
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary w-100"
                                        style={{
                                            borderRadius: '6px',
                                            height: '42px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                        title="Mở Google Maps"
                                        onClick={() => {
                                            if (obj.link_map) {
                                                window.open(obj.link_map, '_blank');
                                            } else {
                                                alert('Vui lòng nhập link trước');
                                            }
                                        }}
                                    >
                                        <i className="fas fa-external-link-alt"></i>
                                        <span className="ml-1 d-none d-md-inline">Mở</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Row 5: Ghi chú */}
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label style={formLabelStyle}>
                                    <i className="fas fa-sticky-note text-warning" style={iconStyle}></i>
                                    Ghi chú
                                </label>
                                <textarea
                                    rows="3"
                                    maxLength="500"
                                    className="form-control"
                                    style={{...formControlStyle, resize: 'vertical', minHeight: '60px'}}
                                    name="ghi_chu"
                                    id="ghi_chu"
                                    value={obj.ghi_chu}
                                    onChange={onChangeInput}
                                    placeholder="Nhập ghi chú..."
                                />
                            </div>
                        </div>

                        {/* Tài liệu Section */}
                        {!isAddMode && (
                            <div ref={taiLieuRef}>
                                <HRTag title="Tài liệu" />
                                <TailieuEdit id={id} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="card-footer">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary mr-1" onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>
            </div>
        </div>
    );
}

export {NhadanEdit};